// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"21670103","384":"4dae44ae","788":"c105f8fb","887":"fecb87f7"}[chunkId] + ".chunk.js";
};